import * as React from 'react';
import { Tag as BaseTag } from '@mc/react-core';
import classNames from 'classnames';

type Props = React.ComponentProps<typeof BaseTag> & {
  full?: boolean; // full width
};

const ClassNameNS = 'react-table';
const ClassName = ` ${ClassNameNS}`;

export class Table extends React.PureComponent<Props> {
  render() {
    const { className, full, children, ...other } = this.props;

    return (
      <table
        {...other}
        className={classNames(ClassName, className, {
          [`w-100`]: full,
        })}
      >
        {children}
      </table>
    );
  }
}
